
































import DictMixin from '@/mixins/dict-mixin';
import { RuleDto } from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class RuleFormTab3 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: RuleDto;

  userInfo: string = '';

  selectUser(user: { userId: string; userName: string }) {
    this.syncFormData.ruleOwnerUid = user.userId;
    this.syncFormData.ruleOwnerName = user.userName;
  }

  @Watch('syncFormData', { deep: true })
  onBaseChange() {
    this.ruleFirstLevel = this.syncFormData.ruleFirstLevel || '';
    this.ruleSecondLevel = this.syncFormData.ruleSecondLevel || '';
    this.ruleThirdLevel = this.syncFormData.ruleThirdLevel || '';
    this.ruleOwnerPlate = this.syncFormData.ruleOwnerPlate || '';
    this.ruleOwnerDept = this.syncFormData.ruleOwnerDept || '';
    if (this.syncFormData.ruleOwnerUid) {
      this.userInfo = `${this.syncFormData.ruleOwnerUid}/${this.syncFormData.ruleOwnerName}`;
    } else {
      this.userInfo = '';
    }
  }

  ruleFirstLevel: string = '';
  ruleSecondLevel: string = '';
  ruleThirdLevel: string = '';

  SUB_SCENE: any[] = [];

  @Watch('ruleFirstLevel')
  changeIndFirstLevel(e: string) {
    if (!e) return false;
    if (!this.DICT_JOURNEY_SCENE) {
      setTimeout(() => {
        this.changeIndFirstLevel(e);
      }, 100);
      return false;
    }
    this.SUB_SCENE = [];
    if (e) {
      let item = this.DICT_JOURNEY_SCENE.find((v: any) => v.value === e);
      this.SUB_SCENE = this.DICT_JOURNEY_SUB_SCENE.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.ruleFirstLevel = e;
  }

  SCENE_STEP: any[] = [];
  @Watch('ruleSecondLevel')
  changeIndSecondLevel(e: string) {
    if (!e) return false;
    if (this.SUB_SCENE.length === 0) {
      setTimeout(() => {
        this.changeIndSecondLevel(e);
      }, 100);
      return false;
    }
    this.SCENE_STEP = [];
    if (e) {
      let item = this.SUB_SCENE.find((v: any) => v.value === e);
      this.SCENE_STEP = this.DICT_JOURNEY_SCENE_STEP.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.ruleSecondLevel = e;
  }

  @Watch('ruleThirdLevel')
  changeIndThirdLevel(e: string) {
    if(!e) return false;
    this.syncFormData.ruleThirdLevel = e;
  }

  ruleOwnerPlate: string = '';
  ruleOwnerDept: string = '';
  DEPT_LIST: any[] = [];
  @Watch('ruleOwnerPlate')
  changePlate(e: string) {
    if (!this.DICT_BUSINESS_UNIT) {
      setTimeout(() => {
        this.changePlate(e);
      }, 100);
      return false;
    }
    this.DEPT_LIST = [];
    if (e) {
      let item = this.DICT_BUSINESS_UNIT.find((v: any) => v.value === e);
      this.DEPT_LIST = this.DICT_BUSINESS_DEPT.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.ruleOwnerPlate = e;

    // 当前部门信息不在部门列表中时置空部门信息
    if (this.ruleOwnerDept && this.ruleOwnerDept.length > 0 && this.DEPT_LIST.filter(v => v.value == this.ruleOwnerDept).length === 0) {
      this.ruleOwnerDept = '';
      this.changeDept(this.ruleOwnerDept);
    }
  }

  @Watch('ruleOwnerDept')
  changeDept(e: string) {
    this.syncFormData.ruleOwnerDept = e;
  }
}
